import { Item, Ordered, OrderedTitle } from "./helperComponents";
import PolicyContent, { ContentItem } from "./PolicyContent";

const selfAddress = <span className="break-all mx-1 font-semibold">https://isentos.motivapagamentos.com.br</span>;
const youBold = <span className="font-semibold">Você</span>;
const motivaBold = <span className="font-semibold">MOTIVA</span>;

const usePolicyStructure: ContentItem[] = [
	{
		title: "",
		content: (
			<>
				<p>Bem-vindo ao {selfAddress}!</p>
				<p>
					A seguir apresentamos os Termos e Condições de Uso (&quot;Termos&quot;), documento que relaciona as principais regras que devem
					ser observadas por todos que acessam o {selfAddress} da {motivaBold} responsável pelo site ou utilizam suas funcionalidades
					(&quot;
					{youBold}&quot;).
				</p>
				<p>
					Como condição para acesso e uso das funcionalidades do {selfAddress} , {youBold} declara que fez a{" "}
					<span className="underline">leitura completa e atenta das regras deste documento</span>, tomando plena ciência de seu conteúdo.
				</p>
				<p>
					Se {youBold} estiver de acordo com as regras apresentadas, deverá se manifestar neste sentido ao cadastrar-se no
					{selfAddress} , por meio da seleção da <span className="italic">checkbox</span> “Li, compreendi e concordo com os Termos de Uso do
					{selfAddress} ”, demonstrando seu <span className="underline">consentimento livre, expresso e informado</span>.
				</p>
				<p>
					Caso {youBold} discorde de alguma das previsões destes Termos, solicitamos que não acesse ou utilize os serviços do
					{selfAddress} .
				</p>
			</>
		)
	},
	{
		title: <OrderedTitle marker="1.">Funcionalidades do {selfAddress}</OrderedTitle>,
		content: (
			<Ordered>
				<Item marker="1.1." leadingText="Funcionalidade.">
					O {selfAddress} consiste em uma plataforma para que os usuários conheçam a MOTIVA e/ou a concessionária, obtenham informações
					sobre as particularidades do negócio e acessem documentos relevantes, assim como consulta de débitos, pagamento do Free Flow e
					participem do Programa de Benefícios.
				</Item>
				<Item marker="1.2." leadingText={<span>Modo de Funcionamento do {selfAddress}.</span>}>
					Os usuários podem interagir com a MOTIVA e/ou a concessionária por meio do envio de mensagens no Fale Conosco e Ouvidoria.
				</Item>
				<Item marker="1.3." leadingText="Maioridade.">
					O acesso e utilização do {selfAddress} é livre para todos, porém algumas funcionalidades como cadastros em determinados ambientes
					podem exigir atos praticados por maiores de 18 (dezoito) anos, conforme legislação em vigor.
					<Ordered>
						<Item marker="1.3.1.">
							Nestes casos, os representantes legais deverão supervisionar e representar as crianças e adolescentes com idade inferior a
							16 (dezesseis) anos e assistir os adolescentes em idade superior à 16 (dezesseis) anos e inferior à 18 (dezoito) anos,
							sempre que aplicável.
						</Item>
						<Item marker="1.3.2.">
							A {motivaBold}. poderá recusar, não aprovar, cancelar ou limitar quaisquer solicitações, caso {youBold} não forneça dados
							corretos.
						</Item>
						<Item marker="1.3.3.">
							O mesmo será aplicável durante a utilização do {selfAddress} , se o mesmo for utilizado de forma fraudulenta, bem como que
							tente ou viole estes Termos ou quaisquer legislações vigentes.
						</Item>
					</Ordered>
				</Item>
				<Item marker="1.4." leadingText="Elegibilidade.">
					A {motivaBold} poderá alterar os critérios de elegibilidade de acesso e utilização do {selfAddress} a qualquer momento e a seu
					critério sem a necessidade de comunicação ou aviso prévio à {youBold} ou qualquer terceiro.
				</Item>
				<Item marker="1.5." leadingText="E-mails.">
					Ao fornecer seus dados no {selfAddress} , {youBold} concorda que poderá receber no e-mail e/ou telefone informados no cadastro,
					mensagens com avisos e conteúdo publicitário de produtos ou serviços da {motivaBold} e de seus parceiros. Através do próprio{" "}
					{selfAddress} {youBold} terá sempre a opção de não receber tais comunicações.
				</Item>
				<Item marker="1.6." leadingText={<span>Apresentação do {selfAddress}.</span>}>
					O {selfAddress} e suas funcionalidades são apresentadas a {youBold} na maneira como estão disponíveis, podendo passar por
					constantes aprimoramentos e atualizações.
					<Ordered>
						<Item marker="1.6.1.">
							Neste caso a {motivaBold} se compromete a preservar a funcionalidade do {selfAddress} com esforços razoáveis, com Links
							não quebrados e utilizando Layout que respeita a usabilidade e navegabilidade, sempre que possível, bem como exibir as
							funcionalidades de maneira clara, completa, precisa e suficiente de modo que exista uma correta percepção do que está
							sendo praticado.
						</Item>
					</Ordered>
				</Item>
			</Ordered>
		)
	},
	{
		title: <OrderedTitle marker="2.">Uso do {selfAddress}</OrderedTitle>,
		content: (
			<Ordered>
				<Item marker="2.1." leadingText={<span>Integridade do {selfAddress}.</span>}>
					{youBold} se compromete a não acessar áreas de programação do {selfAddress} , seu banco de dados, códigos fonte ou qualquer outro
					conjunto de dados disponíveis estes ambientes, bem como não realizar ou permitir engenharia reversa, nem traduzir, decompilar,
					copiar, modificar, reproduzir, alugar, sublicenciar, publicar, divulgar, transmitir, emprestar, distribuir ou, de outra maneira,
					dispor inapropriadamente das funcionalidades do {selfAddress} .
				</Item>
				<Item marker="2.2." leadingText="Não mineração.">
					É vedado a utilização de softwares de mineração de dados do {selfAddress} , de qualquer tipo ou espécie, além de outro aqui não
					tipificado que atue de modo similar.
				</Item>
				<Item marker="2.3." leadingText="Indenização.">
					Na incidência de danos à {motivaBold} ou a terceiros, o responsável se compromete a arcar com todas as obrigações de indenizar o
					sujeito lesado, inclusive aqueles cuja origem for de atos praticados por meio de sua Conta de Acesso, assumindo o polo passivo de
					ação judicial ou procedimento administrativo e requerendo a exclusão da {motivaBold}, devendo arcar totalmente com as despesas e
					custas processuais atinentes, deixando-a livre de prejuízos e ônus.
				</Item>
			</Ordered>
		)
	},
	{
		title: <OrderedTitle marker="3.">Conteúdo, Dados Submetidos e Propriedade Intelectual</OrderedTitle>,
		content: (
			<Ordered>
				<Item marker="3.1." leadingText="Conteúdo.">
					Exceto se estabelecido em contrário por estes Termos, todas as informações, notícias, imagens, ilustrações, ícones, tecnologias,
					marcas e demais conteúdos audiovisuais ou sonoros, incluindo o software do {selfAddress} , disponibilizados em qualquer idioma ou
					forma, são de exclusiva propriedade da {motivaBold} ou licenciado por terceiros à {motivaBold} (“Conteúdo”). A utilização do{" "}
					{selfAddress} não representa qualquer presunção transferência ou licença dessa propriedade. Por essa razão, {youBold} não deverá
					comercializar no todo ou em parte o Conteúdo por quaisquer meios, onerosamente ou não, sabendo que se o fizer poderá ser
					penalizado civil e penalmente pela {motivaBold} e/ou por qualquer terceiro titular do Conteúdo.
					<Ordered>
						<Item marker="3.1.1.">
							A eventual remoção, bloqueio ou suspensão de qualquer Conteúdo ou funcionalidade do {selfAddress}
							em decorrência de alguma reclamação, deverá ser sempre compreendida como demonstração de boa-fé e intenção de solução
							amigável de conflitos, jamais como reconhecimento de culpa ou de qualquer infração pela {motivaBold} a direito de
							terceiro.
						</Item>
					</Ordered>
				</Item>
				<Item marker="3.2." leadingText="Seus Dados.">
					{youBold} é e continuará sendo o titular e proprietário de todos os dados, informações, textos, imagens, mensagens ou qualquer
					outro material de qualquer forma for submetido e/ou compartilhado no {selfAddress} por {youBold} (“Seus Dados”) bem como será o
					exclusivo responsável por eles, cabendo exclusivamente à {youBold} o cuidado em respeitar a propriedade intelectual de terceiros
					ou quaisquer outros direitos conexos.
				</Item>
				<Item marker="3.3." leadingText="Legalidade dos Seus Dados.">
					A {motivaBold} não se obrigará a processar ou tratar quaisquer dos Seus Dados se houver razões para crer que tal processamento ou
					tratamento possa imputar à {motivaBold} qualquer infração de qualquer lei aplicável ou que o {selfAddress}
					esteja sendo utilizado, sob critério exclusivo da {motivaBold}, para quaisquer fins ilegais, ilícitos ou contrários à moralidade.
				</Item>
				<Item marker="3.4." leadingText="Ausência de garantias quanto a Seus Dados e ao Conteúdo.">
					A {motivaBold} não garante a qualidade, coerência, integridade, forma, atualização ou fonte do Conteúdo ou de Seus Dados, pois não
					controla, verifica ou faz juízo deste Conteúdo e de Seus Dados. A {motivaBold} não é responsável, portanto, por quaisquer
					inveracidade, desatualização ou erro deste Conteúdo ou de Seus Dados, bem como não é responsável por quaisquer danos oriundos
					deste Conteúdo, a qualquer título.
					<Ordered>
						<Item marker="3.4.1.">
							{youBold} em nenhuma hipótese deverá tomar qualquer decisão, onerosa ou não, baseado integralmente no Conteúdo ou em
							qualquer funcionalidade do {selfAddress} .
						</Item>
					</Ordered>
				</Item>
				<Item marker="3.5." leadingText="Armazenamento.">
					A {motivaBold} não presta e o {selfAddress} não constitui serviço de armazenamento, portanto a {motivaBold} não possui qualquer
					obrigação de armazenar, reter ou fornecer à {youBold} ou a quaisquer terceiros cópia de Seus Dados ou qualquer Conteúdo.
				</Item>
				<Item marker="3.6." leadingText="Inteligência algorítmica.">
					O {selfAddress} , de forma impessoal e automática, poderá aplicar modelos estatísticos e inteligência algorítmica para indexar,
					filtrar e organizar o Conteúdo ou Seus Dados, gerados ou compartilhados por meio do
					{selfAddress} .
					<Ordered>
						<Item marker="3.6.1.">
							{youBold} se declara ciente que a {motivaBold}, senão por seu exclusivo critério, não divulgará ou fornecerá à {youBold}{" "}
							ou a qualquer terceiro quaisquer informações sistêmicas ou algorítmicas relacionadas ao {selfAddress} .
						</Item>
					</Ordered>
				</Item>
			</Ordered>
		)
	},
	{
		title: <OrderedTitle marker="4.">Sua privacidade e seus dados pessoais</OrderedTitle>,
		content: (
			<Ordered>
				<Item marker="4.1." leadingText="Dados Pessoais.">
					Caso {youBold} trate ou transmita no âmbito do {selfAddress} informações relativas a uma pessoa física identificada ou
					identificável (“Dados Pessoais”), {youBold} será o exclusivo responsável por coletar as autorizações necessárias perante o titular
					dos Dados Pessoais.
					<Ordered>
						<Item marker="4.1.1.">
							A {motivaBold} monitorará, por meios adequados, sua própria conformidade com as respectivas obrigações de proteção de
							Dados Pessoais, caso aplicável.
						</Item>
					</Ordered>
				</Item>
				<Item marker="4.2." leadingText="Registros.">
					A {motivaBold} poderá registrar todas as atividades efetuadas por {youBold} no {selfAddress} , incluindo dados de identificação,
					do dispositivo e da conexão utilizada (“Registros”).
				</Item>
				<Item marker="4.3." leadingText="Finalidade da Coleta.">
					Os Registros poderão ser utilizados com a finalidade de: (i) identificar {youBold} e atendê-lo (ii) cumprir as obrigações destes
					Termos (iii) aperfeiçoar o {selfAddress} ; (iv) resguardar direitos e obrigações relacionadas ao uso do
					{selfAddress} ; e (v) cumprir ordem judicial e/ou de autoridade administrativa.
				</Item>
			</Ordered>
		)
	},
	{
		title: <OrderedTitle marker="5.">Isenção e limitações de responsabilidade</OrderedTitle>,
		content: (
			<Ordered>
				<Item marker="5.1.">
					A {motivaBold} envida seus esforços para a manutenção da disponibilidade contínua e permanente do {selfAddress}. No entanto, pode
					ocorrer, eventualmente, alguma indisponibilidade temporária decorrente de manutenção necessária ou mesmo gerada por motivo de
					força maior, como desastres naturais, falhas nos sistemas de comunicação e acesso à Internet, ataques cibernético invasivos, ou
					quaisquer fatos de terceiro que fogem da esfera de vigilância e responsabilidade da {motivaBold}.
					<Ordered>
						<Item marker="5.1.1.">
							Se isso ocorrer, a {motivaBold} fará o que estiver ao seu alcance para restabelecer o acesso ao
							{selfAddress} o mais breve possível, dentro das limitações técnicas de seus serviços e serviços de terceiros, dos quais
							depende para ficar online. Por essa razão, {youBold} fica ciente que não poderá pleitear indenização ou reparação de danos
							no caso de o {selfAddress} permanecer fora do ar, independente da motivação.
						</Item>
						<Item marker="5.1.2.">
							Eventuais procedimentos de manutenção que acarretem a indisponibilidade do {selfAddress} por longos períodos serão
							informados por meio dos canais oficiais de comunicação da {motivaBold}.
						</Item>
					</Ordered>
				</Item>
				<Item marker="5.2.">
					Sem prejuízo de outras condições destes Termos, a MOTIVA não se responsabiliza:
					<Ordered>
						<Item marker="i.">
							Por quaisquer problemas, <i>bugs</i>, <i>glitches</i> ou funcionamentos indevidos que ocorrerem nos seus dispositivos e
							equipamentos;
						</Item>
						<Item marker="ii.">
							Por qualquer dano direto ou indireto ocasionado por eventos de terceiros, a exemplo, mas não se limitando a ataque de
							hackers, falhas no sistema, no servidor ou na conexão à internet, inclusive por ações de softwares que possam, de algum
							modo, danificar seus ativos físicos ou lógicos em decorrência do acesso, utilização ou navegação no
							{selfAddress} , bem como a transferência de dados, arquivos, imagens, textos, áudios ou vídeos contidos no {selfAddress} ;
						</Item>
						<Item marker="iii.">
							Pela sua navegação em quaisquer links externos disponibilizados no {selfAddress} , sendo seus deveres a leitura dos Termos
							e Condições de Uso e da Política de Privacidade do recurso acessado e agir conforme o determinado; e
						</Item>
						<Item marker="iv.">
							Por verificar, controlar, aprovar ou garantir a adequação ou exatidão das informações ou dados disponibilizados em tais
							links, não sendo, portanto, responsáveis por prejuízos, perdas ou danos ocorridos pela visita de tais sites, cabendo ao
							interessado verificar a confiabilidade das informações e dados ali exibidos antes de tomar alguma decisão ou praticar
							algum ato.
						</Item>
					</Ordered>
				</Item>
			</Ordered>
		)
	},
	{
		title: <OrderedTitle marker="6.">Outras disposições</OrderedTitle>,
		content: (
			<Ordered>
				<Item marker="6.1." leadingText="Canais de Atendimento.">
					{youBold} poderá utilizar os Canais de Comunicação disponibilizados no {selfAddress} toda vez que tiver alguma dúvida, sugestão ou
					reclamação, seja sobre o {selfAddress} ou sobre estes Termos.
				</Item>
				<Item marker="6.2." leadingText="Atualização dos Termos.">
					Estes Termos estão sujeitos a constante melhoria e aprimoramento. Assim, a {motivaBold} se reserva o direito de modificá-los a
					qualquer momento, conforme sua finalidade ou conveniência, tal qual para adequação e conformidade legal de disposição de lei ou
					norma que tenha força jurídica equivalente, incluindo de órgãos reguladores, ou seja, {youBold} deverá verificá-lo sempre que
					efetuar o acesso no {selfAddress} .
					<Ordered>
						<Item marker="6.2.1.">
							Ocorrendo atualizações nestes Termos, a {motivaBold} notificará {youBold} pelas ferramentas disponíveis no
							{selfAddress} ou pelos meios de contato fornecidos por {youBold}.
						</Item>
						<Item marker="6.2.2.">
							Ao navegar pelo {selfAddress} e utilizar suas funcionalidades, {youBold} aceita guiar-se pelos Termos que se encontram
							vigentes na data de acesso. Por isso, é recomendável que {youBold} se mantenha atualizado das condições vigentes.
						</Item>
					</Ordered>
				</Item>
				<Item marker="6.3." leadingText="Novação e renúncia.">
					A tolerância do eventual descumprimento de quaisquer condições destes Termos não constituirá renúncia ou novação nem impedirá a{" "}
					{motivaBold} de exigir estas condições a qualquer tempo.
				</Item>
				<Item marker="6.4." leadingText="Nulidade.">
					Se alguma disposição destes Termos for julgada inaplicável ou sem efeito, o restante continuará a viger normalmente.
				</Item>
				<Item marker="6.5." leadingText="Comunicação.">
					Você reconhece que toda comunicação realizada por e-mail (ao endereço de e-mail informado no seu cadastro) é válida, eficaz e
					suficiente para a divulgação de qualquer assunto que se refira ao {selfAddress} .
				</Item>
				<Item marker="6.6." leadingText="Data e hora.">
					O {selfAddress} tem como base a data e horários oficiais de Brasília (UTC/GMT -03:00).
				</Item>
				<Item marker="6.7." leadingText="Lei aplicável e foro.">
					stes Termos serão interpretados segundo a legislação brasileira, no idioma português, e fica eleito o foro da Comarca da comarca
					do seu domicílio ({youBold}) para dirimir qualquer controvérsia, salvo se a legislação aplicável ressalvar especificamente outra
					competência pessoal, territorial ou funcional.
				</Item>
			</Ordered>
		)
	},
	{
		title: <OrderedTitle marker="7.">Glossário</OrderedTitle>,
		content: (
			<Ordered>
				<Item marker="i." leadingText="MOTIVA">
					MOTIVA, pessoa jurídica de direito privado, com sede na Avenida Chedid Jafet, 222, Bloco B, 5º andar, Bairro Vila Olímpia,
					Município de São Paulo, Estado de São Paulo, inscrita no CNPJ/MF sob nº 02.846.056/0001-97, neste ato representada na forma
					prevista em seu Estatuto Social
				</Item>
				<Item marker="ii." leadingText="https://isentos.motivapagamentos.com.br">
					Ferramenta online, disponibilizada pela {motivaBold} para o site consiste em uma plataforma para que os usuários conheçam as
					concessionárias de rodovias CCR RioSP, CCR ViaLagos, CCR AutoBAn, CCR ViaOeste, CCR RodoAnel, CCR SPVias, ViaRio, CCR ViaSul, CCR
					ViaCosteira e CCR MSVia e obtenham informações sobre as particularidades do negócio e acessem documentos relevantes.
				</Item>
				<Item marker="iii." leadingText="Anti-Spam.">
					Sistema que evita correspondências não desejadas, como publicidade em massa, pelo bloqueio de mensagens ou as movendo para pasta
					específica.
				</Item>
				<Item marker="iv." leadingText="Canais de Comunicação.">
					{selfAddress} contato
				</Item>
				<Item marker="v." leadingText="Layout.">
					Conjunto compreendido entre aparência, design e fluxos do{" "}
					<span className="break-all mx-1 font-semibold">https://rodovias.motiva.com.br/</span> .
				</Item>
				<Item marker="vi." leadingText="Link.">
					Terminologia para endereço de internet.
				</Item>
			</Ordered>
		)
	},
	{
		title: "",
		content: (
			<>
				<br />
				<br />
				<p>Atualização: dezembro de 2024</p>
			</>
		)
	}
];

export default function TermsOfUse(): JSX.Element {
	return <PolicyContent content={usePolicyStructure} />;
}
